// Event listener utility to suppress passive event listener warnings
export const configurePassiveEventListeners = () => {
  // Add passive event listeners for common scroll-blocking events
  if (typeof window !== 'undefined') {
    // Override addEventListener to make touch events passive by default
    const originalAddEventListener = EventTarget.prototype.addEventListener;

    EventTarget.prototype.addEventListener = function(type, listener, options) {
      // Make touchstart, touchmove, wheel, and mousewheel events passive by default
      const passiveEvents = ['touchstart', 'touchmove', 'wheel', 'mousewheel'];

      if (passiveEvents.includes(type) && typeof options !== 'object') {
        options = { passive: true };
      } else if (passiveEvents.includes(type) && typeof options === 'object' && options.passive === undefined) {
        options.passive = true;
      }

      originalAddEventListener.call(this, type, listener, options);
    };

    // Also handle the cleanup when navigating
    window.addEventListener('beforeunload', () => {
      // Reset any scroll-related styles
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }, { passive: true });
  }
};

// Function to clean up event listeners during logout
export const cleanupEventListeners = () => {
  if (typeof window !== 'undefined') {
    // Reset scroll styles
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";

    // Force garbage collection of event listeners
    const elements = document.querySelectorAll('*');
    elements.forEach(element => {
      // Clone and replace to remove all event listeners
      if (element.parentNode) {
        const newElement = element.cloneNode(true);
        element.parentNode.replaceChild(newElement, element);
      }
    });
  }
};
